import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../../../core/reducers';
import { currentUser } from 'src/app/core/auth';
import { TranslateService } from '@ngx-translate/core';
import { Meeting, TaskService } from 'src/app/core/timeline';
import { MeetingService } from 'src/app/core/timeline/_services/meeting.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { DatePipe } from '@angular/common';
import { switchMap } from 'rxjs/operators';
import {
  AttachmentsService,
  ContactRelationshipsService,
  ContactsService,
  DoctorService,
  DrugService,
  FacilitiesService,
  PatientsService,
  SharedHttpRequestService,
} from 'src/app/core/lists/_services';
import { UserService } from 'src/app/core/auth/_services';
import { LayoutUtilsService, MessageType } from 'src/app/core/_base/crud';
import { CreateContactDialogComponent } from '../../../../../partials/content/general/contact-add-dialog/contact-add.dialog.component';
import { GeneralAutocompleteComponent } from '../../../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { clone, isEqual, uniqBy, uniqWith } from 'lodash-es';
import { selectLastCreatedContact } from '../../../../../../core/lists';
import { StringUtilsService } from '../../../../../../core/services/string-utils.service';
import { tagsViewContext } from '../../../../../../core/lists/_services/shared-http-request.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-meeting-edit',
  templateUrl: './meeting-edit.component.html',
  styleUrls: ['./meeting-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingEditComponent implements OnInit, OnDestroy, AfterViewInit {
  showFileLoader = new BehaviorSubject(false);
  totalFileSize = 1;
  uploadRequests: any[];
  private callback;
  participantTypeCtrl = new FormControl();
  searchParticipantsFn = this.searchParticipants.bind(this);
  searchAffiliatesFn = this.searchAffiliates.bind(this);
  searchAssigneeFn = this.userService.searchUsers.bind(this.userService);
  organizerAutocompleteCall = this.userService.searchUsers.bind(this.userService);
  affiliateTypeCtrl = new FormControl();
  drugAutocompleteCall = this.drugService.searchDrugs.bind(this.drugService);
  @ViewChild('drugAutocomplete') drugAutocomplete: GeneralAutocompleteComponent;
  filterAssigneeFn = (val) => {
    if (!val) return '';
    let res = '';
    if (val.name) {
      res = val.name;
    }
    if (val.fullName) {
      res = val.fullName;
    }
    return res;
  };
  formatNewEntityFn = ((value) => {
    return value;
  }).bind(this);
  formatAssigneeEntityFn = ((value) => {
    return value;
  }).bind(this);

  formatAffiliatesEntityFn = ((value) => {
    return value;
  }).bind(this);

  meeting: Meeting;
  companyId: number;
  selectedTab = 0;
  loadingSubject = new BehaviorSubject<boolean>(true);
  loading$: Observable<boolean>;
  meetingForm: FormGroup;
  hasFormErrors = false;
  submissionErrorObj: any;
  hasSubmissionErrors: boolean;
  private subscriptions: any[] = [];
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  files: any[] = [];
  is_completedChecked = false;
  is_importantChecked = false;
  sender_name: string;
  participantCtrl = new FormControl();
  participants = [];
  assigneeCtrl = new FormControl();
  filteredAssignees: Observable<any[]>;
  assignees = [];
  affiliateCtrl = new FormControl();
  filteredAffiliates: Observable<any[]>;
  affiliates = [];
  clicked = false;
  newContact;
  tags = new FormControl();
  @ViewChild('participantInput') participantInput: ElementRef<HTMLInputElement>;
  @ViewChild('assigneeInput') assigneeInput: ElementRef<HTMLInputElement>;
  @ViewChild('entityAutocomplete') entityAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('organizerAutocomplete') organizerAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('responsibleAutocomplete') responsibleAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('affiliatesAutocomplete') affiliatesAutocomplete;
  fileData: File = null;
  attachments = [];
  private pp = [];
  private cloningArr = [];
  tags$ = new BehaviorSubject<any>([]);
  readOnlyTags = [];
  loadingTags = true;
  deletedAttachments = [];
  updatedAttachments = [];
  updatedFiles = [];
  constructor(
    public dialogRef: MatDialogRef<MeetingEditComponent>,
    private contactsService: ContactsService,
    private userService: UserService,
    private patientsService: PatientsService,
    private doctorService: DoctorService,
    private facilitiesService: FacilitiesService,
    private store: Store<AppState>,
    private router: Router,
    private meetingFB: FormBuilder,
    private meetingService: MeetingService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    public datepipe: DatePipe,
    private layoutUtilsService: LayoutUtilsService,
    public stringUtils: StringUtilsService,
    private drugService: DrugService,
    private contactRelationshipsService: ContactRelationshipsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private taskService: TaskService,
    private drugsService: DrugService,
    private sharedHttpRequestService: SharedHttpRequestService,
    private attachmentsService: AttachmentsService,
  ) {
    this.participantTypeCtrl.setValue('CONTACT');
    this.affiliateTypeCtrl.setValue('DOCTOR');
    this.participantCtrl.valueChanges.subscribe(() => {
      this.searchParticipants();
    });
    this.assigneeCtrl.valueChanges
      .pipe(
        switchMap((value) =>
          value && value.length >= 3 ? this.userService.searchUsers(value) : of([]),
        ),
      )
      .subscribe((result) => {
        this.filteredAssignees = result.data ? this.filter(result.data, 2) : of([]);
        this.cdr.detectChanges();
      });
    this.affiliateTypeCtrl.valueChanges.subscribe(() => {
      this.searchAffiliates();
    });
  }

  ngOnInit() {
    const userSub = this.store.pipe(select(currentUser)).subscribe((res) => {
      if (!res) {
        this.router.navigateByUrl('/timeline/meetings');
      }
      this.companyId = res !== undefined ? res.companyID : 1;
      this.sender_name = res && res.fullName ? res.fullName : '';
    });
    this.subscriptions.push({ id: 1, sub: userSub });
    const contactSub = this.store
      .pipe(select(selectLastCreatedContact))
      .subscribe((res) => (this.newContact = res));
    this.subscriptions.push({ id: 2, sub: contactSub });
    this.loading$ = this.loadingSubject.asObservable();
    this.loadingSubject.next(true);
    const newMeeting = new Meeting();
    newMeeting.clear();
    this.createForm();
    this.loadingSubject.next(false);
    this.participantTypeCtrl.valueChanges.subscribe(() => {
      this.entityAutocomplete.triggerReload();
    });
    this.affiliateTypeCtrl.valueChanges.subscribe(() => {
      this.affiliatesAutocomplete.triggerReload();
    });
  }

  private loadTags() {
    if (this.meeting)
      this.sharedHttpRequestService
        .getTagsForView(this.meeting.id, tagsViewContext.COMMUNICATION)
        .subscribe(
          (tags) => {
            this.readOnlyTags = tags.data;
            this.tags$.next(tags.data);
            this.loadingTags = false;
          },
          () => {
            this.readOnlyTags = [];
            this.loadingTags = false;
          },
        );
  }

  ngAfterViewInit(): void {
    if (!this.data || this.data?.mode === 'create') {
      this.store.pipe(select(currentUser)).subscribe((res) => {
        if (res) {
          const newParticipant = [res].map((value) => {
            return {
              id: value.id,
              email: value.email,
              type: 'USER',
              name: value.fullName,
            };
          });
          this.organizerAutocomplete.setValue(newParticipant[0]);
          this.organizerAutocomplete.updateValueAndValidity();
          this.cdr.detectChanges();
        }
      });
    }
    if (this.data?.mode === 'update') {
      this.fillMeeting();
    }
  }

  fillMeeting() {
    const controls = this.meetingForm.controls;
    if (this.data?.salesCall) {
      this.meeting = this.data.salesCall;
      this.loadAttachments();
    }
    // fill normal controls
    controls.from_time.setValue(
      this.meeting ? new Date(this.meeting.from_time + ' UTC') : new Date(),
    );
    controls.subject.setValue(this.meeting?.subject);
    controls.body.setValue(this.meeting?.body);
    controls.location.setValue(this.meeting?.location);
    controls.sales_call_type.setValue(this.meeting?.sales_call_type);
    controls.is_completed.setValue(this.meeting?.is_completed);
    controls.is_important.setValue(this.meeting?.is_important);

    // fill duration
    if (this.meeting?.duration) {
      if (this.meeting.duration % 1 === 0 || this.meeting.duration % 1 === 0.5) {
        controls.duration.setValue(this.meeting.duration);
        controls.duration_type.setValue('H');
      } else {
        controls.duration.setValue(Math.floor(this.meeting.duration * 60));
        controls.duration_type.setValue('M');
      }
    }
    // fill call organizer
    if (this.data.call_organizer) {
      const organizerExist = [this.data.call_organizer].map((value) => {
        return {
          id: value.id,
          email: value.email,
          type: 'USER',
          name: value.fullName,
        };
      });
      this.organizerAutocomplete.setValue(organizerExist[0]);
    }

    // fill drug
    if (this.meeting?.drug_id) {
      this.drugsService.getDrugsByIds([this.meeting.drug_id]).subscribe((res) => {
        controls.drug.setValue(res.data?.[0]);
        this.drugAutocomplete.setValue(res.data?.[0]);
        controls.drug.updateValueAndValidity();
        this.cdr.detectChanges();
      });
    }
    // fill Tags
    this.loadTags();
    this.cdr.detectChanges();

    // fill Responsible and Organizer
    if (this.data.salesCall?.receivers?.length > 0) {
      const responsibleExist = this.data.salesCall.receivers.filter(
        (x) => x.type === 'RESPONSIBLE_PERSON',
      );
      if (responsibleExist.length > 0) {
        this.assignees = responsibleExist;
        this.meetingForm.get('responsible').setValue(this.assignees);
        this.responsibleAutocomplete.setValue(this.assignees);
      }
      const contactsExist = this.data.salesCall.receivers.filter((x) => x.type === 'CONTACT');
      this.meetingForm.get('with').setValue(uniqWith(contactsExist, isEqual));
      this.entityAutocomplete.setValue(contactsExist);
      this.cdr.detectChanges();
    }
    // fill entities
    if (this.data.salesCall?.related_to_list?.length > 0) {
      const related_to_list = this.data.salesCall.related_to_list;
      if (related_to_list.length > 0) {
        this.affiliates = related_to_list;
        this.meetingForm.get('related_to_list').setValue(this.affiliates);
        this.affiliatesAutocomplete.setValue(this.affiliates);
      }
      this.cdr.detectChanges();
    }
  }

  loadAttachments() {
    this.attachmentsService.getAttachmentBySalesCall(this.data.salesCall.id).subscribe((result) => {
      const attachment = result.data;
      if (attachment.length > 0) {
        this.attachments = attachment;
        this.cdr.detectChanges();
      }
    });
  }
  getTitle() {
    return this.data?.mode === 'update' ? 'Edit Sales Call' : 'Create Sales Call';
  }

  /**
   * On destroy
   */
  ngOnDestroy() {
    this.cdr.detach();
    this.subscriptions.forEach((el) => {
      if (el.sub) {
        el.sub.unsubscribe();
      }
    });
  }

  /**
   * Create form
   */
  createForm() {
    this.meetingForm = this.meetingFB.group({
      from_time: [new Date()],
      subject: ['', Validators.required],
      with: [[], this.chipListValidator()],
      responsible: [[]],
      drug: [],
      call_organizer: [],
      body: [],
      related_to_list: [[]],
      location: [],
      sales_call_type: [],
      is_completed: [],
      is_important: [],
      duration: [],
      duration_type: [],
    });
  }

  onSubmit() {
    this.hasFormErrors = false;
    const controls = this.meetingForm.controls;
    this.drugAutocomplete.updateValueAndValidity();
    this.organizerAutocomplete.updateValueAndValidity();
    this.entityAutocomplete.updateValueAndValidity();
    /** check form */
    if (this.meetingForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      this.selectedTab = 0;
      return;
    }
    this.clicked = true;
    const request = {
      body: {
        sender_name: this.sender_name,
        attachment_names: this.attachments,
      },
    };
    if (this.data?.salesCall) {
      this.updateMeeting(this.prepareMeeting(), request);
      return;
    }
    this.addMeeting(this.prepareMeeting(), request);
  }

  /**
   * Returns object for saving
   */
  prepareMeeting(): Meeting {
    const controls = this.meetingForm.controls;
    const _meeting = new Meeting();
    _meeting.clear();
    _meeting.duration = 0;
    if (controls.duration.value && controls.duration_type?.value === 'H') {
      _meeting.duration = controls.duration.value;
    }
    if (controls.duration.value && controls.duration_type?.value === 'M') {
      _meeting.duration = controls.duration.value / 60;
    }
    _meeting.id = this.data?.salesCall ? this.data.salesCall.id : 0;
    _meeting.from_time = this.datepipe.transform(
      controls.from_time.value,
      'yyyy-MM-dd HH:mm:ss',
      'utc',
    );
    _meeting.subject = controls.subject.value;
    _meeting.call_organizer = controls.call_organizer.value.id;
    _meeting.sales_call_type = controls.sales_call_type.value;
    _meeting.location = controls.location.value;
    _meeting.with = controls.with.value;
    _meeting.drug_id = controls.drug.value?.id;
    _meeting.body = controls.body.value;
    _meeting.responsible = controls.responsible.value;
    _meeting.receivers = controls.with.value.concat(...controls.responsible.value);
    _meeting.is_important = controls.is_important.value;
    _meeting.is_completed = controls.is_completed.value;
    _meeting.related_to_list = controls.related_to_list.value;
    _meeting.tags = this.tags.value;
    return _meeting;
  }

  /**
   * Add meeting
   *
   * @param _meeting: Meeting
   * @param request: any
   */
  addMeeting(_meeting: Meeting, request) {
    this.meetingService.createMeeting(request, _meeting).subscribe((res) => {
      if (res.body) {
        if (this.files.length === 0) {
          // tslint:disable-next-line:max-line-length
          this.layoutUtilsService.showActionNotification(
            this.translate.instant('MEETING.ADDED'),
            MessageType.Update,
            3000,
            false,
            false,
          );
          this.dialogRef.close(true);
        }
        const obs = [];
        const uuids = res.body.data.pre_signed_urls.map((x) => x.uuid);
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.files.length; i++) {
          obs.push(
            this.meetingService.uploadFiles(res.body.data.pre_signed_urls[i].url, this.files[i]),
          );
          this.totalFileSize += this.files[i].size;
        }
        this.uploadRequests = obs;
        this.callback = this.sendFiles.bind(this, res.body.data.id, uuids);
        this.showFileLoader.next(true);
      }
    });
  }

  updateMeeting(meeting: Meeting, request) {
    const newAttachmentsFromUser = this.updatedAttachments;
    let newPreSignedUrls = [];
    this.attachmentsService
      .getPreSignedURLs(meeting.id, newAttachmentsFromUser)
      .subscribe((preSignedUrl) => {
        newPreSignedUrls = preSignedUrl.data;
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < newPreSignedUrls.length; i++) {
          this.meetingService
            .uploadFiles(newPreSignedUrls[i].url, this.updatedFiles[i])
            .subscribe();
          request.body.attachment_names.push(newPreSignedUrls[i]);
        }

        this.meetingService.updateMeeting(request, meeting).subscribe((res) => {
          if (res.body) {
            if (this.files.length === 0) {
              // tslint:disable-next-line:max-line-length
              this.layoutUtilsService.showActionNotification(
                this.translate.instant('MEETING.ADDED'),
                MessageType.Update,
                3000,
                false,
                false,
              );
              this.dialogRef.close(true);
            }
          }
        });
      });
  }

  upload(url, file) {
    return this.meetingService.uploadFiles(url, file);
  }

  sendFiles(id, uuids) {
    this.meetingService.sendFiles(id, uuids).subscribe((res) => {
      if (res === null) {
        // tslint:disable-next-line:max-line-length
        this.layoutUtilsService.showActionNotification(
          this.translate.instant('MEETING.ADDED'),
          MessageType.Update,
          3000,
          false,
          false,
        );
        this.dialogRef.close(true);
      }
    });
  }

  onFileChange(event) {
    for (const file of event.target.files) {
      this.attachments.push(file.name);
      this.files.push(file);
    }
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.meetingForm.controls[controlName];
    if (!control) {
      return false;
    }
    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  selected(type: number, val): void {
    this.pp = val;
    switch (type) {
      case 1: {
        const newParticipant = val.map((cont) => {
          const value = Object.create(cont);
          // tslint:disable-next-line:no-shadowed-variable
          const type =
            value.type ||
            (this.participantTypeCtrl.value === 'DOCTOR' ||
            this.participantTypeCtrl.value === 'FACILITY'
              ? 'ENTITY'
              : this.participantTypeCtrl.value);
          Object.defineProperty(value, 'type', { value: type, configurable: true });
          return {
            id: value.id,
            email: value.email,
            type,
            name:
              type === 'USER'
                ? value.fullName
                  ? value.fullName
                  : value.name
                : type === 'ENTITY' || type === 'CONTACT'
                ? value.name
                  ? value.name
                  : value.first_name + ' ' + value.last_name
                : value.first_name + ' ' + value.last_name,
          };
        });
        this.participants = newParticipant;
        this.meetingForm.get('with').setValue(this.participants);
        this.participantCtrl.setValue(null);
        this.contactRelationshipsService
          .searchRelationsByContactIds(newParticipant.map((ele) => ele.id))
          .subscribe((res) => {
            const allEntities: any[] = res.data;
            const filteredEntities: any[] = [];
            allEntities.forEach((ele) => {
              if (ele.entity_type === 'FACILITY' || ele.entity_type === 'DOCTOR') {
                filteredEntities.push(ele);
              }
            });
            const defaultAffiliate = filteredEntities.map((value) => {
              // tslint:disable-next-line:no-shadowed-variable
              const type = value.entity_type || this.affiliateTypeCtrl.value;
              value.type = type;
              return {
                id: value.entity_id,
                email: value.email,
                type,
                name:
                  type !== 'FACILITY'
                    ? value.first_name + ' ' + value.last_name
                    : value.name || value.last_name,
              };
            });
            this.affiliates = defaultAffiliate;
            this.meetingForm.get('related_to_list').setValue(this.affiliates);
            const newPar = this.meetingForm.get('related_to_list').value;
            newPar.concat(defaultAffiliate);
            this.affiliates.concat(defaultAffiliate);
            const cloneAffiliates = clone(defaultAffiliate);
            for (const x of cloneAffiliates) {
              cloneAffiliates[cloneAffiliates.indexOf(x)].name = x.name;
            }
            if (this.cloningArr.length > 0)
              this.cloningArr = this.cloningArr.concat(cloneAffiliates);
            else {
              cloneAffiliates.forEach((ele) => {
                this.cloningArr.push(ele);
              });
            }
            this.meetingForm.get('related_to_list').setValue(uniqBy(newPar, 'id'));
            this.affiliatesAutocomplete.setValue(uniqBy(this.cloningArr, 'id'));
            this.affiliatesAutocomplete.updateValueAndValidity();
          });
        break;
      }
      case 2: {
        const newAssignee = val.map((value) => {
          return {
            id: value.id,
            email: value.email,
            type: 'RESPONSIBLE_PERSON',
            name: value.fullName ? value.fullName : value.name,
          };
        });
        this.assignees = newAssignee;
        this.meetingForm.get('responsible').setValue(this.assignees);
        this.assigneeCtrl.setValue(null);
        break;
      }
      case 3: {
        this.cloningArr = val;
        const newAffiliate = val.map((valueRes) => {
          const value = Object.create(valueRes);
          // tslint:disable-next-line:no-shadowed-variable
          const type =
            value.type ||
            (this.affiliateTypeCtrl.value === 'DOCTOR'
              ? 'DOCTOR'
              : this.affiliateTypeCtrl.value === 'FACILITY'
              ? 'FACILITY'
              : this.affiliateTypeCtrl.value);
          Object.defineProperty(value, 'type', { value: type, configurable: true });
          return {
            id: value.id,
            email: value.email,
            type,
            name: value.name ? value.name : value.first_name + ' ' + value.last_name,
          };
        });
        this.affiliates = newAffiliate;
        this.meetingForm.get('related_to_list').setValue(this.affiliates);
        this.affiliateCtrl.setValue(null);
        break;
      }
    }
  }

  filter(arr, type) {
    switch (type) {
      case 1:
        return of(
          arr.filter((objA) => {
            return !this.participants.find((objB) => {
              return objA.id === objB.id;
            });
          }),
        );
      case 2:
        return of(
          arr.filter((objA) => {
            return !this.assignees.find((objB) => {
              return objA.id === objB.id;
            });
          }),
        );
      case 3:
        return of(
          arr.filter((objA) => {
            return !this.affiliates.find((objB) => {
              return objA.id === objB.id;
            });
          }),
        );
    }
    return of([]);
  }

  chipListValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      return !control.value || control.value.length === 0 ? { chipListRequiredError: true } : null;
    };
  }

  searchParticipants(term = '') {
    const type = this.participantTypeCtrl.value;
    const value = term;
    switch (type) {
      case 'DOCTOR':
        return this.doctorService.searchDoctors(value);
      case 'FACILITY':
        return this.facilitiesService.searchFacilities(value);
      case 'CONTACT':
        return this.contactsService.searchContacts(value);
    }
    return of([]);
  }

  searchAffiliates(term = '') {
    const type = this.affiliateTypeCtrl.value;
    const value = term;
    switch (type) {
      case 'DOCTOR':
        return this.doctorService.searchDoctors(value);
      case 'FACILITY':
        return this.facilitiesService.searchFacilities(value);
      case 'PATIENT':
        return this.patientsService.searchPatients(value);
    }
    return of([]);
  }

  close() {
    this.dialogRef.close();
  }

  callbackOnFileLoad() {
    this.callback();
  }

  openContactDialog() {
    const dialogRef = this.dialog.open(CreateContactDialogComponent, {
      width: '90vw',
      disableClose: true,
      hasBackdrop: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.added) {
        const newParticipant = [this.newContact].map((value) => {
          return {
            id: value.id,
            email: value.email,
            type: 'CONTACT',
            name: value.first_name + ' ' + value.last_name,
          };
        });
        const newPar = this.meetingForm.get('with').value;
        newPar.push(newParticipant[0]);
        this.participants.push(newParticipant[0]);
        const cloneUser = clone(this.newContact);
        cloneUser.type = 'CONTACT';
        this.pp.push(cloneUser);
        this.meetingForm.get('with').setValue(uniqWith(newPar, isEqual));
        this.entityAutocomplete.setValue(this.pp);
        this.entityAutocomplete.updateValueAndValidity();
        this.cdr.detectChanges();
      }
    });
  }

  filterDrugFn(event: any): string {
    return event ? event.drug : '';
  }

  onDrugChange(val) {
    this.meetingForm.controls.drug.setValue(val);
    this.meetingForm.controls.drug.updateValueAndValidity();
  }

  onOrganizerChange(val) {
    this.meetingForm.controls.call_organizer.setValue(val);
    this.meetingForm.controls.call_organizer.updateValueAndValidity();
  }

  returnAttachmentNameTooltip(a) {
    if (this.data.salesCall) return this.getAttachmentName(a);
    return a ? a : '';
  }

  getAttachmentName(attachment) {
    return attachment.uuid.substring(attachment.uuid.lastIndexOf('/') + 1);
  }

  getSvgPath(attachment, type?: string) {
    const name =
      this.data.salesCall && type !== 'update' ? this.getAttachmentName(attachment) : attachment;

    switch (name.substring(name.lastIndexOf('.') + 1).toLowerCase()) {
      case 'pdf':
        return 'assets/media/svg/files/pdf.svg';
      case 'png':
        return 'assets/media/svg/files/png.svg';
      case 'jpg':
        return 'assets/media/svg/files/jpg.svg';
      case 'jpeg':
        return 'assets/media/svg/files/jpg.svg';
      case 'csv':
        return 'assets/media/svg/files/csv.svg';
      case 'txt':
        return 'assets/media/svg/files/txt.svg';
      case 'doc':
        return 'assets/media/svg/files/doc.svg';
      case 'docx':
        return 'assets/media/svg/files/doc.svg';
      case 'ppt':
        return 'assets/media/svg/files/ppt.svg';
      case 'html':
        return 'assets/media/svg/files/html.svg';
      case 'xls':
        return 'assets/media/svg/files/svg.svg';
      default:
        return 'assets/media/svg/files/document.svg';
    }
  }

  openLink(event, url) {
    event.stopPropagation();
    window.open(url, '_blank').focus();
  }

  deleteAttachment(attachment, array) {
    if (array === 'latest' && this.data.mode === 'update') {
      this.deletedAttachments.push(attachment.attachmentId);
      this.attachments = this.attachments.filter(
        (att) => att.attachmentId !== attachment.attachmentId,
      );
      return;
    }
    if (array === 'latest' && this.data.mode === 'create') {
      this.attachments = this.attachments.filter((att) => att !== attachment);
      this.files = this.files.filter((att) => att.name !== attachment);
      return;
    }
    this.updatedAttachments = this.updatedAttachments.filter((att) => att !== attachment);
  }
  onFileUpdated(event) {
    for (const file of event.target.files) {
      this.updatedAttachments.push(file.name);
      this.updatedFiles.push(file);
    }
  }
}
